// Piezas visuales del módulo de asesoras. Siguen el lenguaje de las pantallas
// de monitoreo: fondo gris claro, tarjetas blancas con borde gray.200 y el
// morado de la marca como acento.
import { Badge, Box, Flex, Heading, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

export const BRAND = '#574feb';

export function PageHeader({ title, subtitle, breadcrumb, actions }) {
  return (
    <Flex justify="space-between" align={{ base: 'stretch', md: 'flex-end' }} gap={4} mb={6} wrap="wrap">
      <Box minW={0}>
        {breadcrumb && (
          <Flex fontSize="sm" color="gray.500" gap={2} mb={2} wrap="wrap">
            {breadcrumb.map((item, index) => (
              <Flex key={item.label} gap={2}>
                {index > 0 && <Text as="span">›</Text>}
                {item.to ? (
                  <Text as={Link} to={item.to} color={BRAND} _hover={{ textDecoration: 'underline' }}>
                    {item.label}
                  </Text>
                ) : (
                  <Text as="span">{item.label}</Text>
                )}
              </Flex>
            ))}
          </Flex>
        )}
        <Heading as="h1" fontSize={{ base: '22px', md: '26px' }} fontWeight="700" color="gray.800">
          {title}
        </Heading>
        {subtitle && (
          <Text fontSize="sm" color="gray.500" mt={1}>
            {subtitle}
          </Text>
        )}
      </Box>
      {actions && (
        <Flex gap={3} wrap="wrap">
          {actions}
        </Flex>
      )}
    </Flex>
  );
}

export function SectionCard({ title, description, children, actions, padding = 5, ...rest }) {
  return (
    <Box bg="white" border="1px solid" borderColor="gray.200" borderRadius="lg" {...rest}>
      {(title || actions) && (
        <Flex
          justify="space-between"
          align="center"
          gap={3}
          px={padding}
          pt={padding}
          pb={description ? 1 : 3}
          wrap="wrap"
        >
          <Box>
            {title && (
              <Heading as="h2" fontSize="md" fontWeight="600" color="gray.800">
                {title}
              </Heading>
            )}
            {description && (
              <Text fontSize="sm" color="gray.500" mt={1}>
                {description}
              </Text>
            )}
          </Box>
          {actions}
        </Flex>
      )}
      <Box px={padding} pb={padding} pt={title || actions ? 2 : padding}>
        {children}
      </Box>
    </Box>
  );
}

export function StatusBadge({ label, color = 'gray' }) {
  return (
    <Badge
      colorScheme={color}
      variant="subtle"
      textTransform="none"
      fontWeight="600"
      fontSize="xs"
      px={2}
      py={0.5}
      borderRadius="md"
      whiteSpace="nowrap"
    >
      {label}
    </Badge>
  );
}

export function InfoItem({ label, children }) {
  return (
    <Box minW={0}>
      <Text fontSize="xs" color="gray.500" mb={1}>
        {label}
      </Text>
      <Box fontSize="sm" color="gray.800" fontWeight="500" wordBreak="break-word">
        {children || <Text as="span" color="gray.400" fontWeight="400">Sin dato</Text>}
      </Box>
    </Box>
  );
}

export function EmptyState({ title, description, action }) {
  return (
    <Flex direction="column" align="center" textAlign="center" py={10} px={4} gap={2}>
      <Text fontWeight="600" color="gray.700">
        {title}
      </Text>
      {description && (
        <Text fontSize="sm" color="gray.500" maxW="420px">
          {description}
        </Text>
      )}
      {action && <Box mt={3}>{action}</Box>}
    </Flex>
  );
}
